
import React from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import "./BlogDetails.css";

// ...existing code...
const BlogDetails = () => {
  const { name } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Prefer state from navigation, fallback to old static blogs if needed
  const blog = location.state || null;

  if (!blog) return <h2>Blog not found</h2>;

  // SEO meta tags
  const metaTitle = blog.metaTitle || "Blog Details";
  const metaDescription = blog.metaDescription || "Read more about this health topic.";
  const canonicalUrl = `https://kiorhealthcare.com/blog/${blog.url || blog.id || ''}`;

  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={blog.keywords || `${metaTitle}, ${metaDescription}`}/>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <div className="blog_details">
        <div className="coustom_container">
          <Button className="mb-4" onClick={() => navigate(-1)}>
            ← Back
          </Button>

          <img src={blog.image} alt={blog.title} className="details_img" />

          <p className="details_date">{blog.date}</p>

          <h1>{blog.title}</h1>

          <div
            className="details_content"
            dangerouslySetInnerHTML={{ __html:  blog.description }}
          />
        </div>
      </div>
    </>
  );
};

export default BlogDetails;